import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { Third_Party_Bool_Exp } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetThirdPartiesDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';
import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetThirdPartyRegister as useGetThirdPartyRegisterTRPC } from './useGetThirdPartyRegisterTRPC';

export const useGetThirdPartyRegister = (skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const whereFilter = useEntityWhereFilter<Third_Party_Bool_Exp>(
    Parent_Type_Enum.ThirdParty
  );

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetThirdPartiesDocument, {
    variables: {
      where: whereFilter,
    },
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetThirdPartyRegisterTRPC(skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
